import * as XLSX from 'xlsx';

const TIPO_UNIDAD_INVENTARIO = 1;

const ENCABEZADOS_TABLA = ['Código de tienda', 'Nombre del producto', 'Ubicación', 'Cantidad', 'Unidad'];

const obtenerUnidadInventario = (producto) => {
    const unidades = Array.isArray(producto?.unidades) ? producto.unidades : [];

    const unidadBase = unidades.find((u) => u?.tipo === TIPO_UNIDAD_INVENTARIO && Number(u?.cantidad) === 1);

    return unidadBase?.unidad?.nombre || '';
};

const sanitizarNombreHoja = (nombre) => {
    const limpio = (nombre || 'Área').replace(/[\\/?*[\]:]/g, ' ').trim();
    return limpio.slice(0, 31) || 'Área';
};

const generarNombreHojaUnico = (nombreBase, nombresUsados) => {
    let nombreFinal = sanitizarNombreHoja(nombreBase);
    let contador = 2;

    while (nombresUsados.has(nombreFinal)) {
        const sufijo = ` (${contador})`;
        nombreFinal = sanitizarNombreHoja(nombreBase).slice(0, 31 - sufijo.length) + sufijo;
        contador += 1;
    }

    nombresUsados.add(nombreFinal);
    return nombreFinal;
};

const agruparPorAreaYOrganizador = (productos) => {
    const areas = new Map();

    (productos || []).forEach((producto) => {
        (producto?.inventarios || []).forEach((inv) => {
            const idArea = inv?.area?._id || inv?.area?.id;
            if (!idArea) return;

            if (!areas.has(idArea)) {
                areas.set(idArea, {
                    nombre: inv.area.nombre || 'Sin definir',
                    organizadores: new Map()
                });
            }

            const area = areas.get(idArea);

            const idOrganizador = inv?.organizador?._id || inv?.organizador?.id || 'sin-organizador';
            const nombreOrganizador = inv?.organizador?.nombre || 'Sin organizador';

            if (!area.organizadores.has(idOrganizador)) {
                area.organizadores.set(idOrganizador, {
                    nombre: nombreOrganizador,
                    filas: []
                });
            }

            area.organizadores.get(idOrganizador).filas.push({
                codigo: producto?.codigo || '',
                nombre: producto?.nombre || 'Sin definir',
                ubicacion: inv?.ubicacion?.nombre || '',
                cantidad: '',
                unidad: obtenerUnidadInventario(producto)
            });
        });
    });

    return areas;
};

const construirFilasHoja = (area) => {
    const filasHoja = [];

    const organizadoresOrdenados = Array.from(area.organizadores.values()).sort((a, b) => {
        if (a.nombre === 'Sin organizador') return 1;
        if (b.nombre === 'Sin organizador') return -1;
        return a.nombre.localeCompare(b.nombre);
    });

    organizadoresOrdenados.forEach((organizador) => {
        filasHoja.push([`Área: ${area.nombre} / Organizador: ${organizador.nombre}`]);
        filasHoja.push(ENCABEZADOS_TABLA);

        const filasOrdenadas = [...organizador.filas].sort((a, b) => a.nombre.localeCompare(b.nombre));

        filasOrdenadas.forEach((fila) => {
            filasHoja.push([fila.codigo, fila.nombre, fila.ubicacion, fila.cantidad, fila.unidad]);
        });

        filasHoja.push([]);
    });

    return filasHoja;
};

export const generarExcelConteoFisico = (productos) => {
    const areas = agruparPorAreaYOrganizador(productos);

    const workbook = XLSX.utils.book_new();
    const nombresHojasUsados = new Set();

    const areasOrdenadas = Array.from(areas.values()).sort((a, b) => a.nombre.localeCompare(b.nombre));

    areasOrdenadas.forEach((area) => {
        const filasHoja = construirFilasHoja(area);
        const worksheet = XLSX.utils.aoa_to_sheet(filasHoja);

        worksheet['!cols'] = [
            { wch: 18 },
            { wch: 40 },
            { wch: 20 },
            { wch: 12 },
            { wch: 16 }
        ];

        const nombreHoja = generarNombreHojaUnico(area.nombre, nombresHojasUsados);
        XLSX.utils.book_append_sheet(workbook, worksheet, nombreHoja);
    });

    if (!areasOrdenadas.length) {
        const worksheetVacio = XLSX.utils.aoa_to_sheet([['No hay productos con inventario para exportar']]);
        XLSX.utils.book_append_sheet(workbook, worksheetVacio, 'Sin datos');
    }

    const fecha = new Date().toISOString().slice(0, 10);
    XLSX.writeFile(workbook, `Conteo_Fisico_Inventario_${fecha}.xlsx`);
};
